import type Invoice from '@/entities/invoice';
import type InvoiceBatchItem from '@/entities/invoiceBatchItem';
import {getCurrentUserId} from '@/lib/picos/currentLogin';
import newHRTimestamp from '@/lib/picos/timestamp';

/** Save card edits and sending metadata through the same invoice and batch-item path. */
export function saveInvoiceEdits(
    saved: Invoice | undefined,
    current: Invoice,
    source: Invoice,
    batchItem: InvoiceBatchItem | null | undefined,
    saveInvoice: (invoice: Invoice) => void,
    saveBatchItem: (item: InvoiceBatchItem) => void,
): boolean {
    const sameDate = (a?: Date | null, b?: Date | null) => (a?.getTime() ?? null) === (b?.getTime() ?? null);
    const sentChanged = !sameDate(saved?.sentDate, current.sentDate)
        || (saved?.sentUsing ?? null) !== (current.sentUsing ?? null);
    if (sentChanged && batchItem && (!sameDate(batchItem.sentDate, current.sentDate) || batchItem.sentUsing !== current.sentUsing)) {
        const batch = batchItem.clone();
        batch.sentDate = current.sentDate;
        batch.sentUsing = current.sentUsing;
        batch.addedBy = getCurrentUserId();
        batch.addedOn = newHRTimestamp();
        batch.status = 'U';
        saveBatchItem(batch);
    }

    if (current.invoiceStatus === 'F') {
        if (!sentChanged) return false;
        const sent = source.clone();
        sent.sentDate = current.sentDate;
        sent.sentUsing = current.sentUsing;
        saveInvoice(sent);
    }
    else saveInvoice(current);
    return true;
}
